<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12H19M19 12L14 7M19 12L14 17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>